import { toAmount } from "@/shared/amount";
import type { InsuranceSaleOffer } from "@/shared/flow-contracts";

/**
 * The monthly premium, or `null` when the offer carries none. A missing price
 * is never shown as `0`, which would advertise the cover as free.
 */
export const getInsuranceCost = (offer: InsuranceSaleOffer): number | null =>
	toAmount(offer.insuranceCost);
